import Vue from 'vue'
import Router from 'vue-router'

// import lottery from '../view/lottery'
// import confirm from '../view/confirm'
// import lotteryPaySuccess from '../view/lotteryPaySuccess'
// import phoneBill from '../view/phoneBill'
// import feedBack from '../view/feedBack'
// import phoneBillPaySuccess from '../view/phoneBillPaySuccess'
// import payFinally from '../view/payFinally'

// import popup from '../components/popup'
// import paysuccess from '../components/paysuccess'
// import cardservices from '../view/cardservices'
// import opened from '../components/opened'
// import wechat from '../view/wechat'
// import guide from '../view/guide'

Vue.use(Router)

export default new Router({
        mode: 'history',
        base: '/',
        routes: [
        // {
        //     path:'',
        //     redirect:'/lottery',
        // },
        {
            path: '/lottery',
            // component: lottery
            component: () => import('@/view/lottery'),
        },
        {
            path: '/confirm',
            // component: confirm
            component: () => import('@/view/confirm'),
        },
        {
            path: '/lotteryPaySuccess',
            // component: lotteryPaySuccess
            component: () => import('@/view/lotteryPaySuccess'),
        },
        {
            path: '/phoneBill',
            // component: phoneBill
            component: () => import('@/view/phoneBill'),
        },
        {
            path: '/feedBack',
            // component: feedBack
            component: () => import('@/view/feedBack'),
        },
        {
            path: '/phoneBillPaySuccess',
            // component: phoneBillPaySuccess
            component: () => import('@/view/phoneBillPaySuccess'),
        },
        {
            path: '/rechargePhone',
            // component: rechargePhone
            component: () => import('@/view/rechargePhone'),
        },
        {
            path: '/invite',
            // component: invite
            component: () => import('@/view/invite'),
       },
       {
            path: '/inviteQRcode',
            // component: inviteQRcode
            component: () => import('@/view/inviteQRcode'),
       },
       {
            path: '/inviteReward',
            // component: inviteReward
            component: () => import('@/view/inviteReward'),
       },

       {
        path: '/inviteLogin',
        // component: inviteLogin
        component: () => import('@/view/inviteLogin'),
        },
        {
            path: '/secondPromotions',
            // component: secondPromotion1
            component: () => import('@/view/secondPromotion1'),
        },
        {
            path: '/secondPromotiond',
            // component: secondPromotion3
            component: () => import('@/view/secondPromotion3'),
        },
        {
            path: '/secondPromotionx',
            // component: secondPromotion4
            component: () => import('@/view/secondPromotion4'),
        },
        {
            path: '/lotteryFourgrid',
            // component: lotteryFourgrid
            component: () => import('@/view/lotteryFourgrid'),
        },

        {
            path: '/lotteryFourgridSuccess',
            // component: lotteryFourgridSuccess
            component: () => import('@/view/lotteryFourgridSuccess'),
        },


        {
            path: '/activateCardpromote',
            // component: activateCardpromoteKs
            component: () => import('@/view/lottery'),
        },
        {
            path: '/activateCardpromoteKs',
            // component: activateCardpromoteKs
            component: () => import('@/view/activateCardpromoteKs'),
        },
        {
            path: '/pay/:paytype',
            // component: payFinally
            component: () => import('@/view/payFinally'),
            // 如果是成功页
            // beforeEnter: (to, from, next) => {
            //     console.error(to)
            //     console.error(from)
            // }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js